/** i18n namespace → locale JSON filename (when they differ). */
export const I18N_NAMESPACE_FILES: Record<string, string> = {
  paymentFlows: 'payment-flows',
  externalRequests: 'external-requests',
  manageApplePay: 'manage-apple-pay',
  manageCryptoPayments: 'manage-crypto-payments',
};

export const I18N_CORE_NAMESPACES = ['common', 'navigation', 'auth'] as const;

export const I18N_LAZY_NAMESPACES = [
  'payments',
  'disputes',
  'orders',
  'stores',
  'home',
  'profile',
  'processors',
  'subscriptions',
  'customers',
  'products',
  'offers',
  'paymentFlows',
  'taxes',
  'shippings',
  'languages',
  'domains',
  'upsells',
  'postPurchaseRules',
  'settings',
  'club',
  'search',
  'emails',
  'externalRequests',
  'integrations',
  'analytics',
  'storefront',
  'transactions',
  'onboarding',
  'referral',
  'setup',
  'reports',
  'manageApplePay',
  'manageCryptoPayments',
  'rx',
  'notifications',
] as const;

export type I18nLazyNamespace = (typeof I18N_LAZY_NAMESPACES)[number];

export function getLocaleFileName(namespace: string): string {
  return I18N_NAMESPACE_FILES[namespace] ?? namespace;
}
